import { localStorageData } from '../helpers/utils.js';
import collapseSidebar from './Navbar.js';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ReactLogo from '.././assets/images/HairRaiserz.png';
import ReactLogo2 from '.././assets/images/HairRaiserz2.png';
import ReactLogo3 from '.././assets/images/salonbill1.png';

import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import Profileimage from './../assets/images/profile.png';
import Bellicon from './../assets/images/bell.svg';
import BelliconNoBadge from './../assets/images/noBadgeBell.svg';
import Customericon from './../assets/images/people.svg';
import { showToastMessage } from '../helpers/toastr.js';
import { handleBillingListing, modifyRequest, handleNotificationListing, handleAdminNotificationListing } from '../services/billingService.js';
import ProgressBar from '../components/others/ProgressBar.jsx';

const Navbar = ({ handleOrgChange }) => {
  const location = useLocation();

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1); // State for current page
  const [loading, setLoading] = useState(false); // State for loading indicator
  const [hasMore, setHasMore] = useState(true); // State to check if more data is available
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userData);

  const isFirstRender = useRef(true); // Added ref to track initial mount

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const CLEAN_BASE_URL = BASE_URL.replace(/\/api\/?$/, "");
  const storedOrgId = localStorageData.get('organisation'); // Retrieve stored org ID
  const userOrganizations = userData?.get_orgnaisation || [];


  // Find the matching organization if storedOrgId exists
  const matchedOrg = storedOrgId
    ? userOrganizations.find(org => org.organisation_id == storedOrgId)
    : userOrganizations[0]; // If no storedOrgId, pick the first organization

  const logoSrc = matchedOrg?.organisation?.logo
    ? `${CLEAN_BASE_URL.replace("http://", "https://")}/storage/${matchedOrg.organisation.logo}`
    : ReactLogo3;
  // Default logo if no organization logo is found


  // Set appropriate logo source
  // const logoSrc = isTressLounge ? ReactLogo : ReactLogo2;

  const [notification, setNotification] = useState('none');
  const notificationRef = useRef(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const hasAdminRole = userData?.role?.role === 'admin' ? true : false;
  const hasCoOwnerRole = userData?.role?.role === 'co-owner' ? true : false;

  const handleSidebarToggle = () => {
    // Call the collapseSidebar function and toggle the icon state
    collapseSidebar('sidebar-icon-only', 'body');
    setIsSidebarOpen(!isSidebarOpen);
  };

  const logoutUser = () => {
    localStorageData.remove('token');
    window.location.reload();
  };
  // const handleOrgChange = (newOrgId) => {
  //   localStorageData.set('organisation', newOrgId); // Store the selected organization
  //   setData([]); // Clear existing data
  //   setPage(1); // Reset to the first page
  //   setHasMore(true); // Reset the hasMore flag
  //   fetchNotification(1, [newOrgId]); // Fetch data for new organization
  //   handleOrgChange(newOrgId); // Execute the prop function passed to Navbar
  // };

  const toggleNotification = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setNotification(prev => (prev === 'none' ? '' : 'none'));
  };

  const fetchNotification = async (nextPage = 1) => {
    const initialOrgIds = Array.from(document.getElementById('orgId').selectedOptions, option => option.value);
    const status = 1;

    if (loading) return; // Prevent multiple calls while loading

    setLoading(true); // Set loading to true

    try {
      const notificationResult = await handleAdminNotificationListing(initialOrgIds, nextPage); // Pass nextPage
      if (notificationResult?.data) {
        const newData = notificationResult?.data?.data?.data;
        setData(prevData => [...prevData, ...newData]); // Append new data
        setHasMore(notificationResult?.data?.data?.next_page_url !== null);

      }
    } catch (error) {
      showToastMessage('error', error.response?.data?.message || 'Error fetching notifications');
    } finally {
      setLoading(false); // Set loading to false after API call finishes
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      if (hasAdminRole || hasCoOwnerRole) { // Check if the user has an admin or co-owner role
        fetchNotification(page); // Load first page
      }
      isFirstRender.current = false;
    }
  }, [userData, hasAdminRole, hasCoOwnerRole]); // Add relevant dependencies

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setNotification('none');
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAction = async (uuid, service_billing_id, action, requestType) => {
    const formData = { uuid, service_billing_id, type: action, requestType };

    try {
      const result = await modifyRequest(formData);
      if (result.data) {
        // Update the state to mark the notification as read and remove action buttons
        setData(prevData =>
          prevData.map(notification =>
            notification.id === uuid
              ? { ...notification, request_status: action } // Mark as processed
              : notification
          )
        );

        showToastMessage('success', result.data.message);
      }
    } catch (error) {
      if (error.response.status === 404) {
        const errors = error.response.data.message;
        if (errors && Object.keys(errors).length > 0) {
          Object.keys(errors).forEach(key => {
            errors[key].forEach(message => showToastMessage('error', message));
          });
        }
      } else {
        showToastMessage('error', error.response.data.message);
      }
    }
  };


  const copyOtpToClipboard = (otp, index) => {
    navigator.clipboard.writeText(otp)
      .then(() => {
        showToastMessage('success', 'OTP copied to clipboard!');
        const updatedData = [...data];
        updatedData[index].isOtpCopied = true; // Mark OTP as copied
        setData(updatedData); // Update state
      })
      .catch((error) => {
        console.error('Failed to copy OTP:', error);
        showToastMessage('error', 'Failed to copy OTP.');
      });
  };

  const filteredData = data.filter(el => el.outstanding_balance_request_status === 1 || el.status === 1);

  // Load more notifications when user scrolls to the bottom
  const handleLoadMore = () => {
    if (!hasMore || loading) return; // Prevent unnecessary API calls
    setPage(prevPage => {
      const nextPage = prevPage + 1;
      fetchNotification(nextPage);
      return nextPage;
    });
  };


  return (
    <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row nav">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <NavLink className="navbar-brand brand-logo paddingleft-30" to="/">
          <img src={logoSrc} alt="logo" />
        </NavLink>
        <NavLink className="navbar-brand brand-logo-mini" to="/">
          <img src={logoSrc} alt="logo" />
        </NavLink>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
          <span
            className={`mdi ${isSidebarOpen ? 'mdi-close' : 'mdi-menu'}`}
            onClick={handleSidebarToggle}
          ></span>
        </button>
        <ul className="navbar-nav navbar-nav-right gap-4">
          <div className="form-group mb-0">
            <select
              className="form-select h-auto bg-danger-light borderwidth-1 bordercolor-light minwidth-250"
              id="orgId"
              value={localStorageData.get('organisation')}
              onChange={handleOrgChange}
            >
              {userData?.get_orgnaisation?.length > 0 && userData.get_orgnaisation.map(el => (
                <option key={el.organisation_id} value={el.organisation_id}>
                  {el.organisation.name}
                </option>
              ))}
            </select>
          </div>
        </ul>
        {userData?.role?.role !== "manager" && userData?.role?.role !== "accountant" && (
          <ul className="navbar-nav navbar-nav-right navbar-nav-items-right gap-4">
            <div className="d-flex gap-2 align-items-center">
              <li className="nav-item nav-logout d-lg-block dropdown">
                <a className="nav-link icon-md round-100 justify-content-center" onClick={toggleNotification} href="javascript:void(0)">
                  {filteredData.length > 0 || data.length > 0 && userData?.role?.role == "admin" ? (
                    <img src={Bellicon} alt="Notifications" />
                  ) : (
                    <img src={BelliconNoBadge} alt="Notifications" />
                  )}
                </a>
                <div
                  ref={notificationRef} // Attach ref here
                  style={{ display: notification }}
                  className="dropdown-menu dropdown-menu-left navbar-dropdown preview-list show notification-menu"
                  aria-labelledby="notificationDropdown"
                  data-bs-popper="none"
                >
                  <h6 className="p-3 mb-0">Notifications</h6>
                  <div>

                    {data.length > 0 && (
                      data.map((d, index) => (
                        <div
                          key={index}
                          className={`dropdown-item preview-item ${d.request_status === "approved"
                            ? "bg-light-green"
                            : d.request_status === "rejected"
                              ? "bg-light-red"
                              : ""
                            }`}
                        >
                          <div className="preview-thumbnail">
                            <div className="preview-icon bg-success">
                              <i className="mdi mdi-account"></i>
                            </div>
                          </div>
                          <div className="preview-item-content">
                            <p className="w-full mb-1 font-weight-medium">{d.message}</p>
                            {d.request_status === "pending" && (
                              <div className="preview-item-action float-end">
                                <button
                                  type="button"
                                  className="button button-icon button-error"
                                  onClick={() =>
                                    handleAction(
                                      d.id,
                                      d.service_billing_id,
                                      "rejected",
                                      d.outstanding_balance_request_status === 1
                                        ? "out_standing"
                                        : "discount"
                                    )
                                  }
                                >
                                  <i className="mdi mdi-close"></i>
                                </button>
                                <button
                                  type="button"
                                  className="button button-icon button-success"
                                  onClick={() =>
                                    handleAction(
                                      d.id,
                                      d.service_billing_id,
                                      "approved",
                                      d.outstanding_balance_request_status === 1
                                        ? "out_standing"
                                        : "discount"
                                    )
                                  }
                                >
                                  <i className="mdi mdi-check"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    )}


                    {hasMore && data.length > 0 && (
                      <button onClick={handleLoadMore} className="btn btn-primary w-100">
                        {loading ? 'Loading...' : 'Load More'}
                      </button>
                    )}
                    {loading && (
                      <div className="text-center mt-2">
                        <ProgressBar />
                      </div>
                    )}
                  </div>

                </div>
              </li>
            </div>
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
